var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_35",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8_35",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAESklEQVR4nO2YXYgWVRjHZ3VtVRDdUHfXutPKTBQxXaECu1twTdwNuig/W7qQLtoUC0EK2Rtv9KIPqQtdXYTSSgvCBTXsE8TUcPEjP8oLX3NFBVuLXRf8yeP+R6bxzLyz887GG80fXnjnnP/zcc6cec7zPJ6XI0eOHDn+SwCmAa8DW4HjwF/AN0BFAtkK4AfJHJMO0zXt33L+UeAd4ALRqE+gpz5G/oJsPDIUCxgPfAD0BgxeB/YAq4EG4KDGfwL2AaeAG8Bt/ez/Sc0ZB8k0SMde6fRhtt4321ktohG4IuX9wG7gBWAMsFjH4irp0S0dpmuMdH8mW4Y/gAWlLuJZ7SbayceBh4E2h/OXgG3a3YXAk0A1MEK/ao0tFKcdKIR0XAU2iPsE0Klx8+GZtIuoBM5L0SZ9oKtCr/8I0Ao8VcJmTQfeBH4O6L0uW2Zzs8bOmU9pDCyXgt+Ah4BJAUP2duamdb5IEOgM2KmTbfPBsDyN0i4JL9Wz7c4yYH7WC3DYnm+2As9L5UvXYBU9F/jQRgyFsymOeUE+Jf9WgB0SavPKBAwEGMP2pAIjgT8lNMUrEwBT5NNN8zGJgMVzw1GvzMBAOmNYlITcIfI6r8wArJNvHcWIFbppDdO9MgMDdw7yMTo5BWaJWEiYxVo0WQOcVW70qy63yixlQhvtR6+ZXhSAtSK1J1RqeZcLn7o2Io1MGBa1xF8TR/pSpPuXUYKb/4YCxFigSc+GJVnIhAGsEHdPHOmySEULHOBHcVeExl/V+PdZyIRheZ24l+KKJnSHDHOS/sm36s4wITQ+UeO3spAJw3wL3HOTXASrAwyHvAQwo0Wc6slCxgXgO/EbXZMWOQwfOaWjj8nKFEcrsYwLwMfiv+GatFLWsNYp/SB/WeDDbdKH2xz4cF/OQsYF4C3x33NNWo1haHZKu0PpLtz4JCb8DkrGBeBFyXwdV38kLph0udmRPKPL7bS9bmB4ljIxXZgTrsmLmpwaESmeThLNsgIwXDZdb3aqfP3dJejX4nWOudc0dwh4bAj9vwezAXwrmy1eCCqBDdc8x2SfJmsiLqFCoKPxIVDrZQygVrr9zk3B1dgwHzXf51JibU+UpgyLaNJZu+eOeHa+v1CqUVWC86OBl2S3T7rvyNb4iGP+lXjHvYhd9y8sS+xGRxieocjjN9DQTXtQrRvLheapL1WjirPKLkFgsj7UV4CNwIFQ97JfumfELPpzcW9FplLqKvqLORXXMdExWE92MF2RxxV4XhHOX0R891GRwu8jGfZrgQ8cH2CLOF3ivA3sBA6r3ujWjvfq/1nN7RS3MRD2tzj0V4ljb86H+TY7dhEBBaPUuuwJHR977S3AHEu5Nf53KdWkqj7TYVgi3S2y5SeHyJd3zbc0RqqVDtgxi8KqtIsI2LH2aBROyodxpdoJ7lyrOuW/aIc6kqYVRXRXSFePdO8utaecI0eOHDly/C9xF02wifdhaEtaAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.61ac9d006cd73785fbdac737f20e8692.svg";
export { ForwardRef as ReactComponent };